import React from 'react';
import { motion } from 'framer-motion';
import { PagesPill } from './PagesPill';
import { bonuses } from '../data/content';
export function BonusesSection() {
  return <section className="w-full bg-navy-mid px-5 py-10 sm:py-16" data-id="element-21" data-mp="gxzxzfufzhwa">
      <div className="mx-auto max-w-5xl" data-id="element-22" data-mp="vuh863qwaqh9">
        <div className="mx-auto max-w-2xl text-center" data-id="element-23" data-mp="qtt6mo51ir8s">
          <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-24" data-mp="qs8cgzmn1abg">
            🎁 And Everything the Usual Lesson Pack Leaves You to Figure Out.
          </h2>
          <p className="mt-3 text-sm text-white/70 sm:text-base" data-id="element-25" data-mp="ztq1x8lxqoct">
            Planning the lesson is only part of the job. These five tools help you organize the year,
            assess student work, handle unexpected classroom moments, keep visual references ready
            and document student growth.
          </p>
        </div>
        <div className="mt-7 grid gap-4 sm:mt-9 sm:gap-6 md:grid-cols-2" data-id="element-26" data-mp="1nhppjzny9yn6">
          {bonuses.map((bonus, index) => <motion.article key={bonus.badge} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-2xl border border-gold/35 bg-navy p-6 shadow-sm shadow-black/25 sm:p-7 ${index === bonuses.length - 1 && bonuses.length % 2 !== 0 ? 'md:col-span-2 md:mx-auto md:w-[calc(50%-12px)]' : ''}`} data-id="element-27" data-mp="1jgnoddah3cik" data-mpi={index}>
              <div className="flex flex-1 gap-4 sm:gap-6" data-id="element-28" data-mp="gjkdvqrljes3">
                <div className="flex min-w-0 flex-1 flex-col" data-id="element-29" data-mp="ld55n12ljciu">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-30" data-mp="qb6ygdptqq7i">
                    <span className="rounded-md bg-gold px-2.5 py-1 text-[11px] font-bold tracking-wide text-navy" data-id="element-31" data-mp="qaf1ozkhqmfn">
                      {bonus.badge}
                    </span>
                    <PagesPill pages={bonus.pages} data-id="element-32" data-mp="10a60hdg33nlj" />
                    <span className="text-2xl" aria-hidden="true" data-id="element-33" data-mp="akz8c71a7cnx">
                      {bonus.icon}
                    </span>
                  </div>
                  <h3 className="mt-4 text-base font-bold leading-snug text-white sm:text-lg" data-id="element-34" data-mp="5npbi6bkbyq2">
                    {bonus.title}
                  </h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-white/70" data-id="element-35" data-mp="fklk0c1gokum">
                    {bonus.description}
                  </p>
                </div>
                <img src={bonus.coverImage} alt={`Cover of ${bonus.badge.toLowerCase()}: ${bonus.title}`} width="720" height="900" loading="lazy" decoding="async" className="block h-auto w-[96px] shrink-0 self-start object-contain sm:w-[120px]" data-id="element-36" data-mp="tdtb82lmrebs" />
              </div>
              <div className="mt-5 flex items-center justify-between gap-3" data-id="element-37" data-mp="yc4nsl3b82xp">
                <span className="text-sm text-white/55 line-through" data-id="element-38" data-mp="350hkqh5ald1v">{bonus.value}</span>
                <span className="rounded-full bg-gold px-3 py-1 text-xs font-bold text-navy" data-id="element-39" data-mp="302ptzqgdvwz9">
                  INCLUDED TODAY
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}